import { useMemo } from "react"
import { addDays, startOfDay } from "date-fns"
import Tabs from "@/v2-backoffice-client/components/tabs"
import { useRenewalTimelineQuery } from "@/v2-backoffice-client/license/renewals/license.renewals.query"
import {
  buildRenewalEvents,
  RENEWAL_EVENT_KINDS,
} from "@/v2-backoffice-client/license/renewals/license.renewals.utils"
import { LICENSING_VIEW_RENEWALS } from "@/v2-backoffice-client/license/license.constants"

// The Licensing page's Renewals tab trigger: how many cash events (renewals
// and starts — churn excluded) land in the next 90 days. Owns its own read
// of the query — Apollo dedupes it against the board's — so the count stays
// live no matter which tab is open.
function LicenseRenewalTabTrigger() {
  const { data, previousData, loading } = useRenewalTimelineQuery()
  const items = (data ?? previousData)?.getRenewalTimeline

  const next90Count = useMemo(() => {
    if (!items) return 0
    const in90Days = addDays(startOfDay(new Date()), 90)
    return buildRenewalEvents(items).filter(
      (event) =>
        event.kind !== RENEWAL_EVENT_KINDS.CHURNING && event.date <= in90Days,
    ).length
  }, [items])

  return (
    <Tabs.Trigger
      value={LICENSING_VIEW_RENEWALS}
      iconSrc="arrow-trend-up"
      isLoading={loading && !data && !previousData}
      count={next90Count}
    >
      Renewals
    </Tabs.Trigger>
  )
}

export default LicenseRenewalTabTrigger
